import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { CatalogNode } from '../models/CatalogNode';

export interface GetSortedChildrenInput {
  application: string;
  sort: any;
  catalogs?: string[];
  parents?: string[];
  pageSize?: number;
  specificClass?: string;
  returnFields?: string[];
  returnParentFields?: string[];
}

export interface GetSortedChildrenOutput {
  hits?: number;
  return?: CatalogNode[];
}

export function getSortedChildren(input: GetSortedChildrenInput): Promise<FetchResponse<GetSortedChildrenOutput>> {
  return portalCustomAPI.fetch<GetSortedChildrenInput, GetSortedChildrenOutput>('getSortedChildren', input);
}
